import React from 'react';

import FollowButton, {
  FollowableType
} from '@buyside/components/presentation/FollowButton/followButton';

import { BUTTON_SIZES } from '@buyside/components/presentation/Button/button';

import styles from './styles.scss';

const WhitePaperShowPageSubcategory: React.FC<{
  category: keyof typeof FollowableType;
  id: string;
  name: string;
}> = ({ category, id, name }) => {
  return (
    <div className={styles.subcategory}>
      <p className={styles.subcategoryName}>{name}</p>
      <FollowButton
        analyticsTag={`follow-${category.toLowerCase()}`}
        id={id}
        size={BUTTON_SIZES.TINIEST}
        type={category}
      />
    </div>
  );
};

export default WhitePaperShowPageSubcategory;
